<template>
    <v-container fluid>
        <v-card-text>
            <v-row no-gutters>
                <v-col cols="12" md="12">
                    <!-- <v-switch></v-switch> -->
                    <!-- <v-switch color="secondary" v-model  :label="'Appliquer pour les factures suivantes'" v-if="allowDisableSaveInCompany"></v-switch> -->
                </v-col>
                <v-col cols="12" md="12" class="py-2">
                    <v-textarea-filled
                        label="Détails du paiement"
                        auto-grow
                        min-rows="3"
                        v-model="company.invoiceTextPaymentDetails"
                    >
                        <template v-slot:append-inner>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <v-btn-icon
                                            icon="$fa-redo-alt"
                                            size="small"
                                            :disabled="
                                                company.invoiceTextPaymentDetails ===
                                                defaultPaymentDetails
                                            "
                                            @click="
                                                company.invoiceTextPaymentDetails =
                                                    defaultPaymentDetails
                                            "
                                        />
                                    </div>
                                </template>
                                <span>Remettre les valeurs par défauts</span>
                            </v-tooltip>
                        </template>
                    </v-textarea-filled>
                </v-col>
                <v-col cols="12" md="12" class="py-2">
                    <v-textarea-filled
                        label="Mentions légales*"
                        auto-grow
                        min-rows="3"
                        v-model="company.invoiceTextLegalNotices"
                    >
                        <template v-slot:append-inner>
                            <v-tooltip location="bottom">
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <v-btn-icon
                                            icon="$fa-redo-alt"
                                            size="small"
                                            :disabled="
                                                company.invoiceTextLegalNotices === defaultLegalForm
                                            "
                                            @click="
                                                company.invoiceTextLegalNotices = defaultLegalForm
                                            "
                                        />
                                    </div>
                                </template>
                                <span>Remettre les valeurs par défauts</span>
                            </v-tooltip>
                        </template>
                    </v-textarea-filled>
                </v-col>
                <!-- Champ pour le mode de paiement -->
                <v-col cols="12" md="12" class="py-2">
                    <v-textarea-filled
                        label="Mode de paiement"
                        auto-grow
                        min-rows="3"
                        v-model="company.invoiceTextPaymentMode"
                        data-cy="LegalForm-paymentMode"
                    >
                        <template v-slot:append-inner>
                            <div class="d-flex flex-column align-center">
                                <v-btn-icon
                                    icon="$edit"
                                    size="small"
                                    @click="openPaymentModeWizard"
                                    v-tooltip:bottom="'Configurer le mode de paiement'"
                                    data-cy="LegalForm-paymentMode-edit"
                                />
                                <v-btn-icon
                                    icon="$fa-redo-alt"
                                    size="small"
                                    :disabled="!company.invoiceTextPaymentMode"
                                    @click="resetPaymentMode"
                                    v-tooltip:bottom="'Remettre les valeurs par défaut'"
                                />
                            </div>
                        </template>
                    </v-textarea-filled>
                </v-col>
            </v-row>
            <v-row class="d-flex align-end">
                <v-col cols="12" md="12" class="d-flex justify-end">
                    <v-btn
                        data-cy="LegalForm-Engregistrer"
                        elevation="0"
                        @click="saveInvoiceSettings()"
                        size="small"
                    >
                        Enregistrer
                    </v-btn>
                    <!-- <v-switch></v-switch> -->
                    <!-- <v-switch color="secondary" v-model  :label="'Appliquer pour les factures suivantes'" v-if="allowDisableSaveInCompany"></v-switch> -->
                </v-col>
            </v-row>
        </v-card-text>
        <!-- Payment mode wizard configuration -->
        <PaymentModeWizard
            v-model="isWizardDialogOpen"
            :companyId="companyId"
            @paymentModeSelected="updatePaymentMode"
        />
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";

import { Apollo } from "@/decorators";
import { defaultLegalForm } from "../../services/companyServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import PaymentModeWizard from "./PaymentModeWizard.vue";

@Component({
    components: {
        PaymentModeWizard,
    },
    emits: [
        "paymentDetails-changed",
        "legalNotices-changed",
        "paymentMode-changed",
        "saved-info",
        "changed-info",
    ],
})
export class LegalForm extends Vue {
    @Prop({ default: null }) companyId: string;
    @Prop({ default: false }) allowDisableSaveInCompany: boolean;

    isSavingInvoiceDetails: boolean = false;

    saveInCompany: boolean = true;

    savedLegalNotices = "";
    isWizardDialogOpen: boolean = false;

    @Apollo({
        query: gql`
            query company($companyId: ID!) {
                company(where: { id: $companyId }) {
                    id
                    invoiceTextPaymentDetails
                    invoiceTextLegalNotices
                    invoiceTextPaymentMode
                    name
                    siren
                    vatNumber
                    legalForm
                    shareCapital
                    registrationTown
                    activities {
                        id
                        name
                        description
                    }
                    address
                    postalCode
                    city
                }
            }
        `,
        skip() {
            return !this.companyId;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data && data.company) {
                this.company = data.company;
                // if (this.company.invoiceTextPaymentDetails === null) {
                //     this.company.invoiceTextPaymentDetails = this.$t("invoice.paymentDetails");
                // }
                if (!this.company.invoiceTextLegalNotices) {
                    this.company.invoiceTextLegalNotices = this.defaultLegalForm;
                }
                this.savedLegalNotices = this.company.invoiceTextLegalNotices;
            } else {
                this.company = {
                    id: "",
                    invoiceTextPaymentDetails: "",
                    invoiceTextLegalNotices: "",
                    invoiceTextPaymentMode: "",
                    name: "",
                    siren: "",
                    vatNumber: "",
                    shareCapital: 0,
                    registrationTown: "",
                    activities: [],
                    address: "",
                    postalCode: "",
                    city: "",
                };
            }
        },
    })
    company = {
        id: "",
        invoiceTextPaymentDetails: "",
        invoiceTextLegalNotices: "",
        invoiceTextPaymentMode: "",
        name: "",
        siren: "",
        vatNumber: "",
        shareCapital: 0,
        registrationTown: "",
        activities: [],
        address: "",
        postalCode: "",
        city: "",
    };

    get defaultLegalForm() {
        return defaultLegalForm(this.company);
    }

    get defaultPaymentDetails() {
        return this.$t("invoice.paymentDetails");
    }

    @Watch("company.invoiceTextPaymentDetails")
    onPaymentDetailsChanged(value) {
        // this.saveInvoiceSettings();
        this.$emit("paymentDetails-changed", this.company.invoiceTextPaymentDetails);
        this.emitChanges();
    }

    @Watch("company.invoiceTextLegalNotices")
    invoiceTextLegalNoticesChanged(value) {
        // this.saveInvoiceSettings();
        this.$emit("legalNotices-changed", this.company.invoiceTextLegalNotices);
        this.emitChanges();
    }

    @Watch("company.invoiceTextPaymentMode")
    invoiceTextPaymentModeChanged() {
        this.$emit("paymentMode-changed", this.company.invoiceTextPaymentMode);
        this.emitChanges();
    }

    updatePaymentMode(paymentText: string) {
        this.company.invoiceTextPaymentMode = paymentText;
    }

    emitChanges() {
        this.$emit("changed-info", {
            companyId: this.companyId,
            paymentDetails: this.company.invoiceTextPaymentDetails || "",
            legalNotices: this.company.invoiceTextLegalNotices || "",
            paymentMode: this.company.invoiceTextPaymentMode || "",
        });
    }

    resetPaymentMode() {
        this.company.invoiceTextPaymentMode = "";
    }

    openPaymentModeWizard() {
        this.isWizardDialogOpen = true;
    }

    async saveInvoiceSettings() {
        if (this.saveInCompany && !this.isSavingInvoiceDetails) {
            this.isSavingInvoiceDetails = true;
            await this.$apollo.mutate({
                mutation: gql`
                    mutation (
                        $companyId: ID!
                        $paymentDetails: String!
                        $legalNotices: String!
                        $paymentMode: String!
                    ) {
                        updateCompany(
                            where: { id: $companyId }
                            data: {
                                invoiceTextPaymentDetails: $paymentDetails
                                invoiceTextLegalNotices: $legalNotices
                                invoiceTextPaymentMode: $paymentMode
                            }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    companyId: this.companyId,
                    paymentDetails: this.company.invoiceTextPaymentDetails || "",
                    legalNotices: this.company.invoiceTextLegalNotices || "",
                    paymentMode: this.company.invoiceTextPaymentMode || "",
                },
            });
            this.isSavingInvoiceDetails = false;
            this.$apollo.queries.company.refetch();
            this.$emit("saved-info", {
                companyId: this.companyId,
                paymentDetails: this.company.invoiceTextPaymentDetails || "",
                legalNotices: this.company.invoiceTextLegalNotices || "",
                paymentMode: this.company.invoiceTextPaymentMode || "",
            });
        }
    }
}

export default toNative(LegalForm);
</script>
